export const CUSTOM_LANDING_PAGE_REDIRECT_QUERY_PARAM_KEY = 'landingPage';
